/*!
 * Wish Karo - product page extras (no dependencies)
 * 1) Sticky add-to-cart bar: proxies the theme's real Add to cart button,
 *    so variant validation, cart drawer and analytics all stay native.
 * 2) Age-based size helper: parses size values like "2-3 Years" / "6-9 Months",
 *    recommends one for the child's age and selects it through the theme's own picker.
 */
(function () {
  'use strict';
  if (window.__wkPdp) return;
  window.__wkPdp = true;

  var STORE_KEY = 'wk_child_age_v1';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function text(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function raf(fn) { return window.requestAnimationFrame(fn); }

  function onVariantChange(fn) {
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
      try { window.subscribe(window.PUB_SUB_EVENTS.variantChange, fn); return; } catch (e) {}
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-selects')) setTimeout(fn, 400);
    });
  }

  function selectedVariant(scope) {
    var node = $('variant-selects [data-selected-variant]', scope);
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  /* ---------------------------------------------------------------- */
  /* 1. Sticky add to cart                                            */
  /* ---------------------------------------------------------------- */

  function initSticky(bar) {
    // Live directly under <body> so no transformed ancestor can break position: fixed
    if (bar.parentElement !== document.body) document.body.appendChild(bar);
    var section = bar.getAttribute('data-section');
    var scope = document.getElementById('MainProduct-' + section) || document;
    var priceEl = $('[data-wk-price]', bar);
    var sizeEl = $('[data-wk-size]', bar);
    var btn = $('[data-wk-add]', bar);
    var label = $('[data-wk-label]', bar);
    var real = null, io = null, mo = null;
    var inView = true, shown = false;

    function realBtn() { return document.getElementById('ProductSubmitButton-' + section); }

    function syncFromReal() {
      var r = realBtn();
      if (!r) return;
      var disabled = r.hasAttribute('disabled') || r.getAttribute('aria-disabled') === 'true';
      btn.disabled = r.hasAttribute('disabled');
      label.textContent = text($('span', r)) || label.textContent;
      bar.classList.toggle('is-loading', r.classList.contains('loading'));
      bar.classList.toggle('is-disabled', disabled && !r.classList.contains('loading'));
    }

    function syncPriceSize() {
      var box = document.getElementById('price-' + section);
      if (box) {
        var p = $('.price--on-sale .price-item--sale', box) ||
                $('.price__regular .price-item--regular', box) ||
                $('.price-item', box);
        priceEl.textContent = text(p);
      }
      // Show just the size (e.g. "3-4 Years"), not the full "Colour / Size" title
      var v = selectedVariant(scope);
      var tag = '';
      if (v && v.title && v.title !== 'Default Title') {
        tag = v.title;
        (v.options || []).some(function (o) { if (parseRange(o)) { tag = o; return true; } return false; });
      }
      sizeEl.textContent = tag;
      sizeEl.hidden = !tag;
    }

    function update() {
      if (!bar.isConnected) document.body.appendChild(bar);
      var drawerOpen = document.body.classList.contains('overflow-hidden');
      var want = !!real && !inView && window.scrollY > 180 && !drawerOpen;
      if (want === shown) return;
      shown = want;
      bar.classList.toggle('is-visible', want);
      bar.setAttribute('aria-hidden', want ? 'false' : 'true');
      btn.tabIndex = want ? 0 : -1;
      document.body.classList.toggle('wk-sticky-on', want);
      if (want) document.body.style.setProperty('--wk-sticky-h', bar.offsetHeight + 'px');
    }

    function watch() {
      var r = realBtn();
      if (r === real) return;
      if (io && real) io.unobserve(real);
      if (mo) mo.disconnect();
      real = r;
      if (!real) { update(); return; }
      if (!io) {
        io = new IntersectionObserver(function (entries) {
          inView = entries[entries.length - 1].isIntersecting;
          update();
        }, { rootMargin: '0px 0px -40px 0px' });
      }
      io.observe(real);
      mo = new MutationObserver(syncFromReal);
      mo.observe(real, { attributes: true, attributeFilter: ['disabled', 'class', 'aria-disabled'], childList: true, subtree: true, characterData: true });
      syncFromReal();
    }

    btn.addEventListener('click', function () {
      var r = realBtn();
      if (!r || r.hasAttribute('disabled')) return;
      r.click();
    });

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      raf(function () { ticking = false; update(); });
    }, { passive: true });

    new MutationObserver(update).observe(document.body, { attributes: true, attributeFilter: ['class'] });

    onVariantChange(function () { watch(); syncFromReal(); syncPriceSize(); });

    watch();
    syncPriceSize();
    update();
  }

  /* ---------------------------------------------------------------- */
  /* 2. Age-based size helper                                         */
  /* ---------------------------------------------------------------- */

  // "2-3 Years" -> [24, 36), "06-12 Months" -> [6, 12), "3 Years" -> [36, 48)
  function parseRange(v) {
    var s = String(v).toLowerCase();
    var m = s.match(/(\d+(?:\.\d+)?)\s*(?:-|–|to)\s*(\d+(?:\.\d+)?)\s*(m(?:on)?(?:th)?s?|y(?:ea)?r?s?)\b/);
    var unit, lo, hi;
    if (m) {
      lo = parseFloat(m[1]); hi = parseFloat(m[2]); unit = m[3];
    } else {
      m = s.match(/(\d+(?:\.\d+)?)\s*(m(?:on)?(?:th)?s?|y(?:ea)?r?s?)\b/);
      if (!m) return null;
      lo = parseFloat(m[1]); unit = m[2];
      hi = unit.charAt(0) === 'y' ? lo + 1 : lo + 3;
    }
    if (unit.charAt(0) === 'y') { lo *= 12; hi *= 12; }
    if (!(hi > lo)) return null;
    return { lo: lo, hi: hi };
  }

  function fmtAge(months) {
    var y = Math.floor(months / 12), mo = months % 12;
    if (!y) return mo + (mo === 1 ? ' month' : ' months');
    return y + (y === 1 ? ' yr' : ' yrs') + (mo ? ' ' + mo + ' mo' : '');
  }

  function loadAge() {
    try {
      var d = JSON.parse(localStorage.getItem(STORE_KEY) || 'null');
      if (!d || typeof d.m !== 'number') return null;
      var elapsed = Math.floor((Date.now() - d.at) / (30.44 * 24 * 3600 * 1000));
      return { m: Math.min(d.m + Math.max(elapsed, 0), 14 * 12 + 11), up: !!d.up };
    } catch (e) { return null; }
  }

  function saveAge(m, up) {
    try { localStorage.setItem(STORE_KEY, JSON.stringify({ m: m, up: !!up, at: Date.now() })); } catch (e) {}
  }

  function isVisible(el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
  }

  // Find the size picker and describe its options. Supports the theme's own picker
  // and the swatch app (.mpg-swatch) that replaces it on some products.
  function findSizePicker(scope) {
    var found = [];

    $$('.mpg-swatch__option-set', scope).forEach(function (set) {
      var name = set.getAttribute('os-name') || text($('.mpg-swatch__label-option', set));
      if (!/size|age/i.test(name)) return;
      var opts = [];
      $$('.mpg-swatch__option', set).forEach(function (o) {
        var v = o.getAttribute('o-value') || text(o);
        var r = parseRange(v);
        if (r) opts.push({ value: v, lo: r.lo, hi: r.hi, el: o, label: o, sold: o.classList.contains('disabled') });
      });
      if (opts.length >= 2) found.push({ group: set, select: null, opts: opts, kind: 'mpg' });
    });

    $$('variant-selects fieldset, variant-selects .product-form__input--dropdown', scope).forEach(function (g) {
      var title = text($('legend, label.form__label', g));
      if (!/size|age/i.test(title)) return;
      var opts = [];
      var select = $('select', g);
      if (select) {
        $$('option', select).forEach(function (o) {
          var r = parseRange(o.value);
          if (r) opts.push({ value: o.value, lo: r.lo, hi: r.hi, el: o, label: null, sold: /sold|unavailable/i.test(o.textContent) });
        });
      } else {
        $$('input[type="radio"]', g).forEach(function (inp) {
          var r = parseRange(inp.value);
          var lab = g.querySelector('label[for="' + inp.id + '"]');
          if (r) opts.push({ value: inp.value, lo: r.lo, hi: r.hi, el: inp, label: lab, sold: inp.classList.contains('disabled') });
        });
      }
      if (opts.length >= 2) found.push({ group: g, select: select, opts: opts, kind: 'theme' });
    });

    for (var i = 0; i < found.length; i++) { if (isVisible(found[i].group)) return found[i]; }
    return found[0] || null;
  }

  function recommend(picker, months, sizeUp) {
    var opts = picker.opts.slice().sort(function (a, b) { return a.lo - b.lo || (a.hi - a.lo) - (b.hi - b.lo); });
    var fit = null;
    opts.forEach(function (o) {
      if (months >= o.lo && months < o.hi && (!fit || (o.hi - o.lo) < (fit.hi - fit.lo))) fit = o;
    });
    var note = '';
    if (!fit) {
      if (months < opts[0].lo) { fit = opts[0]; note = 'Smallest size available for this style.'; }
      else { fit = opts[opts.length - 1]; note = 'Largest size for this style – it may be a snug fit.'; }
    }
    var idx = opts.indexOf(fit);
    var next = null;
    for (var j = idx + 1; j < opts.length; j++) { if (opts[j].lo > fit.lo && opts[j].hi > fit.hi) { next = opts[j]; break; } }
    var nearTop = fit.hi - months <= 1;
    var pick = fit;
    if (next && (sizeUp || nearTop)) {
      pick = next;
      note = sizeUp ? 'Sized up for growing room.' : 'Almost outgrowing ' + fit.value + ', so we picked the next size.';
    }
    // If the best size is sold out, only ever suggest the very next size up
    var alt = null;
    if (pick.sold) {
      var after = opts[opts.indexOf(pick) + 1];
      if (after && !after.sold && after.lo > pick.lo) alt = after;
    }
    return { pick: pick, alt: alt, note: note, fit: fit };
  }

  function choose(picker, opt) {
    if (picker.kind === 'mpg') {
      opt.el.click(); // let the swatch app handle the change exactly as a tap would
    } else if (picker.select) {
      picker.select.value = opt.value;
      picker.select.dispatchEvent(new Event('change', { bubbles: true }));
    } else if (opt.el) {
      opt.el.checked = true;
      opt.el.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  var RULER = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" d="M3 15.5 15.5 3 21 8.5 8.5 21z M7 12.5l1.8 1.8 M9.8 9.8l2.6 2.6 M12.5 7l1.8 1.8"/></svg>';

  var sheet = null;
  var sheetState = null;

  function buildSheet() {
    if (sheet) {
      // Some scripts on the page can detach body children; put the sheet back if so
      if (!sheet.isConnected) document.body.appendChild(sheet);
      return sheet;
    }
    sheet = document.createElement('div');
    sheet.className = 'wk-size-sheet';
    sheet.setAttribute('hidden', '');
    sheet.innerHTML =
      '<div class="wk-size-sheet__overlay" data-wk-close></div>' +
      '<div class="wk-size-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="WkSizeTitle">' +
        '<button type="button" class="wk-size-sheet__x" data-wk-close aria-label="Close">&times;</button>' +
        '<p class="wk-size-sheet__eyebrow">' + RULER + ' Size finder</p>' +
        '<h2 class="wk-size-sheet__title" id="WkSizeTitle">How old is your little one?</h2>' +
        '<div class="wk-size-sheet__steppers">' +
          '<div class="wk-step" data-unit="y"><span class="wk-step__label">Years</span>' +
            '<div class="wk-step__row"><button type="button" class="wk-step__btn" data-d="-1" aria-label="Fewer years">&minus;</button>' +
            '<output class="wk-step__val" aria-live="polite">0</output>' +
            '<button type="button" class="wk-step__btn" data-d="1" aria-label="More years">+</button></div></div>' +
          '<div class="wk-step" data-unit="m"><span class="wk-step__label">Months</span>' +
            '<div class="wk-step__row"><button type="button" class="wk-step__btn" data-d="-1" aria-label="Fewer months">&minus;</button>' +
            '<output class="wk-step__val" aria-live="polite">0</output>' +
            '<button type="button" class="wk-step__btn" data-d="1" aria-label="More months">+</button></div></div>' +
        '</div>' +
        '<label class="wk-size-sheet__up"><input type="checkbox" data-wk-up> <span>Size up for growing room</span></label>' +
        '<div class="wk-size-sheet__result" aria-live="polite">' +
          '<span class="wk-size-sheet__result-label">Best fit</span>' +
          '<strong class="wk-size-sheet__result-size" data-wk-result></strong>' +
          '<span class="wk-size-sheet__result-note" data-wk-note></span>' +
        '</div>' +
        '<button type="button" class="button button--primary button--full-width wk-size-sheet__cta" data-wk-select>Select size</button>' +
        '<p class="wk-size-sheet__foot">We remember this for other styles too. Fits vary slightly by design.</p>' +
      '</div>';
    document.body.appendChild(sheet);

    sheet.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-wk-close]')) { closeSheet(); return; }
      var b = t.closest('.wk-step__btn');
      if (b) {
        var unit = b.closest('.wk-step').getAttribute('data-unit');
        var d = parseInt(b.getAttribute('data-d'), 10);
        var y = Math.floor(sheetState.m / 12), mo = sheetState.m % 12;
        if (unit === 'y') y = Math.max(0, Math.min(14, y + d));
        else { mo += d; if (mo > 11) { mo = 0; y = Math.min(14, y + 1); } if (mo < 0) { if (y > 0) { mo = 11; y -= 1; } else mo = 0; } }
        sheetState.m = y * 12 + mo;
        renderSheet();
        return;
      }
      if (t.closest('[data-wk-select]')) {
        var r = sheetState.rec;
        var target = r.pick.sold && r.alt ? r.alt : r.pick;
        saveAge(sheetState.m, sheetState.up);
        choose(sheetState.picker, target);
        closeSheet();
        setTimeout(refreshAll, 450);
      }
    });
    $('[data-wk-up]', sheet).addEventListener('change', function (e) {
      sheetState.up = e.target.checked;
      renderSheet();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheet && !sheet.hasAttribute('hidden')) closeSheet();
    });
    return sheet;
  }

  function renderSheet() {
    var y = Math.floor(sheetState.m / 12), mo = sheetState.m % 12;
    var vals = $$('.wk-step__val', sheet);
    vals[0].textContent = y;
    vals[1].textContent = mo;
    var r = recommend(sheetState.picker, sheetState.m, sheetState.up);
    sheetState.rec = r;
    var res = $('[data-wk-result]', sheet);
    var note = $('[data-wk-note]', sheet);
    var cta = $('[data-wk-select]', sheet);
    res.textContent = r.pick.value;
    res.classList.remove('is-bump');
    void res.offsetWidth;
    res.classList.add('is-bump');
    var msg = r.note;
    if (r.pick.sold) msg = r.alt ? r.pick.value + ' is sold out – ' + r.alt.value + ' is the next best fit.' : r.pick.value + ' is currently sold out.';
    note.textContent = msg || 'For ' + fmtAge(sheetState.m) + '.';
    var target = r.pick.sold && r.alt ? r.alt : r.pick;
    cta.textContent = 'Select ' + target.value;
    cta.disabled = !!(r.pick.sold && !r.alt);
  }

  var lastFocus = null;
  function openSheet(picker) {
    buildSheet();
    var saved = loadAge();
    sheetState = { picker: picker, m: saved ? saved.m : 24, up: saved ? saved.up : false, rec: null };
    $('[data-wk-up]', sheet).checked = sheetState.up;
    renderSheet();
    lastFocus = document.activeElement;
    sheet.removeAttribute('hidden');
    document.body.classList.add('wk-size-open');
    raf(function () { sheet.classList.add('is-open'); $('.wk-step__btn[data-d="1"]', sheet).focus({ preventScroll: true }); });
  }

  function closeSheet() {
    if (!sheet) return;
    sheet.classList.remove('is-open');
    document.body.classList.remove('wk-size-open');
    setTimeout(function () { if (!sheet.classList.contains('is-open')) sheet.setAttribute('hidden', ''); }, 260);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function ensureHelper(scope) {
    var picker = findSizePicker(scope);
    if (!picker) return;
    var saved = loadAge();
    var rec = saved ? recommend(picker, saved.m, saved.up) : null;

    var show = rec ? (rec.pick.sold && rec.alt ? rec.alt : rec.pick) : null;
    picker.opts.forEach(function (o) { if (o.label) o.label.classList.remove('wk-size-rec'); });
    if (show && show.label) show.label.classList.add('wk-size-rec');

    var trigger = $('.wk-size-help', picker.group);
    if (!trigger) {
      trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'wk-size-help';
      var anchor = $('legend', picker.group) || $('label.form__label', picker.group);
      if (anchor && anchor.tagName === 'LEGEND') anchor.appendChild(trigger);
      else if (anchor) anchor.insertAdjacentElement('afterend', trigger);
      else picker.group.insertBefore(trigger, picker.group.firstChild);
    }
    var html = show
      ? RULER + '<span>Your size: <strong>' + show.value + '</strong>' + (show.sold ? ' · sold out' : '') + '</span><span class="wk-size-help__edit">Change</span>'
      : RULER + "<span>Find my child's size</span>";
    // Only touch the DOM when the label changes, so the MutationObserver can't loop
    if (trigger.getAttribute('data-wk-html') !== html) {
      trigger.innerHTML = html;
      trigger.setAttribute('data-wk-html', html);
    }
    trigger.onclick = function (e) {
      e.preventDefault();
      e.stopPropagation();
      openSheet(findSizePicker(scope) || picker);
    };
  }

  var scopes = [];
  function refreshAll() { scopes.forEach(function (s) { ensureHelper(s); }); }

  function initSizeHelper(scope) {
    scopes.push(scope);
    ensureHelper(scope);
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      raf(function () {
        pending = false;
        // (Re)attach when missing, or when it only exists inside a picker that's hidden
        if (!$$('.wk-size-help', scope).some(isVisible)) ensureHelper(scope);
      });
    }).observe(scope, { childList: true, subtree: true });
    onVariantChange(function () { setTimeout(function () { ensureHelper(scope); }, 50); });
  }

  /* ---------------------------------------------------------------- */

  function init() {
    $$('.wk-sticky-atc').forEach(function (bar) {
      try { initSticky(bar); } catch (e) { console.warn('[wk-pdp] sticky', e); }
      var scope = document.getElementById('MainProduct-' + bar.getAttribute('data-section'));
      if (scope) {
        try { initSizeHelper(scope); } catch (e) { console.warn('[wk-pdp] size', e); }
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
